// Shared v1 user/role store for the forecasting module.
// Production replaces this with SSO claims (PRD section 17).

export const FORECAST_USERS = [
  { name: 'Jordan Avery', role: 'liaison', label: 'Jordan Avery — Finance Liaison' },
  { name: 'Priya Raman', role: 'liaison', label: 'Priya Raman — Finance Liaison' },
  { name: 'Marcus Hill', role: 'liaison', label: 'Marcus Hill — Finance Liaison' },
  { name: 'Elena Morris', role: 'liaison', label: 'Elena Morris — Finance Liaison' },
  { name: 'Dana Whitfield', role: 'manager', label: 'Dana Whitfield — FP&A Manager' },
  { name: 'Alex Cardell', role: 'manager', label: 'Alex Cardell — FP&A Manager' },
  { name: 'Central FP&A', role: 'central', label: 'Central FP&A — Corporate Planning' },
  { name: 'Executive Viewer', role: 'executive', label: 'Executive Viewer' }
];

const STORAGE_KEY = 'rfm-active-user';

export const getActiveForecastUser = () => {
  if (typeof window === 'undefined') return FORECAST_USERS[0];
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const match = FORECAST_USERS.find((user) => user.name === stored);
    return match || FORECAST_USERS[0];
  } catch (error) {
    return FORECAST_USERS[0];
  }
};

export const setActiveForecastUser = (name) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, name);
  } catch (error) {
    /* no-op */
  }
};

export const STATUS_LABELS = {
  not_started: 'Not started',
  in_progress: 'In progress',
  submitted: 'Submitted',
  returned: 'Returned',
  approved: 'Approved',
  loaded: 'Loaded'
};

export const STATUS_TONES = {
  not_started: 'neutral',
  in_progress: 'amber',
  submitted: 'gold',
  returned: 'red',
  approved: 'moss',
  loaded: 'moss'
};

export const formatMillions = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return `$${Number(value).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })}MM`;
};

export const formatDollarsAsMillions = (dollars, digits = 1) =>
  formatMillions((Number(dollars) || 0) / 1e6, digits);

export const formatPct = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const numeric = Number(value);
  return `${numeric > 0 ? '+' : ''}${numeric.toFixed(digits)}%`;
};
